class ConferenciaNfeDetailsModal {
    static get $inject() {
        return ['$scope', '$uibModal', 'gql', 'Nfes']
    }

    constructor(scope, modal, gql, Nfes) {
        this.apply = (fn) => scope.$apply(fn)
        this.modal = modal
        this.gql = gql
        this.Nfes = Nfes
    }

    $onInit() {
        this.filial = this.resolve.filial
        this.nfe = this.resolve.nfe
        this.loadingPromise = this.loadNfeTributacao()
    }

    loadNfeTributacao() {
        const query = gql`
            query NfeTributacao($id: String!, $filialId: String!) {
                icmsTributacao(id: $id, filialId: $filialId) {
                    id
                    confiavel
                    percentuaisExtratos {
                        tipoReceita
                        percentual
                        total
                        confiavel
                    }
                    percentuaisLancamentos {
                        tipoReceita
                        percentual
                        total
                        confiavel
                    }
                    itens {
                        id
                        tipoReceita
                        codigoBarras
                        confiavel
                        percentual
                        icmsExtratoItem {
                            id
                            descricao
                            ncm
                            cest
                            aliquotaInterna
                            icmsRecolher
                        }
                    }
                }
            }
        `

        const variables = { id: this.nfe.icmsTributacao.id.toString(), filialId: this.filial.id.toString() }

        return this.gql.query(query, variables)
            .then(({ icmsTributacao }) => this.icmsTributacao = icmsTributacao)
            .catch(console.error)
            .finally(() => this.apply())
    }

    downloadDanfe() {
        this.Nfes.downloadDanfe(this.filial.id, this.nfe.chave)
    }
}

angular.module('eficienciaFiscalModule')
    .component('conferenciaNfeDetailsModal', {
        controller: ConferenciaNfeDetailsModal,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <modal title="Comparação da Tributação ICMS da NF-e" close="$ctrl.close">
            <modal-body>
                <loading promise="$ctrl.loadingPromise">
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="table-condensed">
                                <tr>
                                    <th class="text-left" width="40%">Chave</th>
                                    <td>
                                        <a href="javascript:void(0)" ng-click="$ctrl.downloadDanfe()">
                                            {{ $ctrl.nfe.chave }}
                                        </a>
                                    </td>
                                </tr>

                                <tr>
                                    <th class="text-left" width="40%">Número</th>
                                    <td>{{ $ctrl.nfe.numero }}</td>
                                </tr>

                                <tr>
                                    <th class="text-left" width="40%">Filial</th>
                                    <td>
                                        {{ $ctrl.filial.razaoSocial }} - 
                                        {{ $ctrl.filial.cnpj | cpfCnpj }}
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <div class="col-sm-6">
                            <table class="table-condensed">
                                <tr>
                                    <th class="text-left" width="40%">Resultado</th>
                                    <td>
                                        <span ng-show="$ctrl.icmsTributacao && $ctrl.icmsTributacao.confiavel" class="text-bold text-success">
                                            Valores corretos
                                        </span>
                                        <span ng-hide="$ctrl.icmsTributacao && $ctrl.icmsTributacao.confiavel" class="text-bold text-danger">
                                            Valores divergentes
                                        </span>
                                    </td>
                                </tr>

                                <tr>
                                    <th class="text-left" width="40%">UF Origem</th>
                                    <td>{{ $ctrl.nfe.emitente.uf }}</td>
                                </tr>

                                <tr>
                                    <th class="text-left" width="40%">UF Filial</th>
                                    <td>{{ $ctrl.filial.uf }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <hr/>

                    <div style="margin-top: 20px; display: flex; flex-direction: column;">
                        <b style="padding-left: 5px">Percentuais</b>

                        <div class="tributacao-percentuais">
                            <div>
                                <span class="label">Extrato EF</span>
                                <div>
                                    <span ng-repeat-start="percentual in $ctrl.icmsTributacao.percentuaisExtratos">
                                        <b>{{ percentual.tipoReceita.toUpperCase() }}</b>
                                        <span class="text-muted italic">({{ percentual.percentual | number: 2}} %)</span>
                                    </span>

                                    <i class="arrow text-muted fa fa-long-arrow-right"></i>

                                    <div class="total" ng-repeat-end>
                                        {{ percentual.total | currency }}
                                        <i ng-show="percentual.confiavel" tooltip="Correto" class="confiabilidade fa fa-check text-success"></i>
                                        <i ng-hide="percentual.confiavel" tooltip="Divergente" class="confiabilidade fa fa-times text-danger"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="divider"></div>

                            <div>
                                <span class="label">Lançamento SEFIN</span>
                                <div>
                                    <span ng-repeat-start="percentual in $ctrl.icmsTributacao.percentuaisLancamentos">
                                        <b>{{ percentual.tipoReceita.toUpperCase() }}</b>
                                        <span class="text-muted italic">({{ percentual.percentual | number: 2}} %)</span>
                                    </span>

                                    <i class="arrow text-muted fa fa-long-arrow-right"></i>

                                    <div class="total" ng-repeat-end>
                                        {{ percentual.total | currency }}
                                        <i ng-show="percentual.confiavel" tooltip="Correto" class="confiabilidade fa fa-check text-success"></i>
                                        <i ng-hide="percentual.confiavel" tooltip="Divergente" class="confiabilidade fa fa-times text-danger"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr/>

                    <div style="margin-top: 20px">
                        <h4 style="margin-bottom: 10px">Itens do Extrato ICMS</h4>

                        <table class="table table-condensed table-striped table-hover">
                            <thead>
                                <tr>
                                    <th class="text-middle">Código de barras</th>
                                    <th class="text-middle">Descrição</th>
                                    <th class="text-middle">NCM</th>
                                    <th class="text-middle">CEST</th>
                                    <th class="text-middle">Tipo receita</th>
                                    <th class="text-middle">Percentual</th>
                                    <th class="text-middle">Alíquota interna</th>
                                    <th class="text-middle">ICMS a recolher</th>
                                    <th class="text-center-middle">Resultado</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr ng-repeat="item in $ctrl.icmsTributacao.itens">
                                    <td class="text-middle">{{ item.codigoBarras }}</td>
                                    <td class="text-middle">{{ item.icmsExtratoItem.descricao }}</td>
                                    <td class="text-middle">{{ item.icmsExtratoItem.ncm | efMask:"0000.00.00" }}</td>
                                    <td class="text-middle">
                                        <span ng-show="item.icmsExtratoItem.cest">{{ item.icmsExtratoItem.cest | efMask:"00.000.00" }}</span>
                                        <span ng-hide="item.icmsExtratoItem.cest" class="empty">VAZIO</span>
                                    </td>
                                    <td class="text-middle">{{ item.tipoReceita.toUpperCase() }}</td>
                                    <td class="text-middle">{{ item.percentual | number: 2 }} %</td>
                                    <td class="text-middle">{{ item.icmsExtratoItem.aliquotaInterna | number: 2 }} %</td>
                                    <td class="text-middle">{{ item.icmsExtratoItem.icmsRecolher | currency }}</td>
                                    <td class="text-center-middle">
                                        <i ng-show="item.confiavel" tooltip="Correto" class="fa fa-check text-success"></i>
                                        <i ng-hide="item.confiavel" tooltip="Divergente" class="fa fa-times text-danger"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </loading>
            </modal-body>

            <modal-footer>
                <button class="btn btn-default" type="button" ng-click="$ctrl.close()">
                    Fechar
                </button>
            </modal-footer>
        </modal>
        `
    })
